import { Block } from 'slate';
import getFragmentFromEvent from '../utils/getFragmentFromEvent';
import PerfAnalyticsHelper from '../helpers/PerfAnalyticsHelper';
import { VOID_BLOCKS } from '../../../types/BlockTypes';

function isPastingOnEmptyUnstyled(editor, fragment) {
  var selection = editor.value.selection;
  return selection.isSet && selection.isCollapsed && editor.isDefaultBlock() && editor.isEmptyBlock() && Block.isBlockList(fragment.nodes);
}

function isPastingOnVoidBlock(editor) {
  return editor.value.selection.isCollapsed && VOID_BLOCKS.includes(editor.value.startBlock.type);
}

export default function onPaste(event, editor, next) {
  event.preventDefault();
  event.stopPropagation();
  PerfAnalyticsHelper.start();
  var fragment = getFragmentFromEvent(editor, event);
  if (!fragment || fragment.nodes.isEmpty()) return next(); // If we are pasting on an empty unstyled block, we replace it by the
  // fragment

  if (isPastingOnEmptyUnstyled(editor, fragment)) {
    editor.snapshotSelection();
    var startBlock = editor.value.startBlock;
    editor.insertFragment(fragment);
    startBlock = editor.value.document.getNode(startBlock.key);

    if (startBlock && editor.isEmptyBlock(startBlock)) {
      editor.removeNodeByKey(startBlock.key);
    }

    editor.moveToEndOfText();
    if (fragment.getLastText()) editor.moveToEndOfText();
    PerfAnalyticsHelper.end(editor, fragment);
    return editor;
  }

  if (isPastingOnVoidBlock(editor)) {
    var _startBlock = editor.value.startBlock;
    var ancestor = editor.value.document.getFurthestChild(_startBlock.key);
    editor.moveToRangeOfNode(ancestor).moveToStartOfNextText().removeNodeByKey(_startBlock.key).insertFragment(fragment);
    return editor;
  } // If very first block of pasted content is a simple paragraph, or if pasted
  // content is a single block, we keep the current block type and data


  if (editor.isDefaultBlock(fragment.nodes.first())) {
    fragment = fragment.setIn(['nodes', 0, 'type'], editor.value.startBlock.type).setIn(['nodes', 0, 'data'], editor.value.startBlock.data);
  } else if (fragment.getBlocks().size === 1) {
    fragment = fragment.setIn(['nodes', 0], fragment.getBlocks().first().set('type', editor.value.startBlock.type).set('data', editor.value.startBlock.data));
  }

  editor.snapshotSelection().insertFragment(fragment);
  PerfAnalyticsHelper.end(editor, fragment);
  return editor;
}